import React from "react";
import {convertPath} from "@common/utils/path/linkPath";
import ViewIcon from "../../assets/image/icon_eye.svg";
import Split from "../../assets/image/split.svg";
import {Moments} from "@common/utils/date/moments";
import {LazyLoadImage} from 'react-lazy-load-image-component';

function LargeCardVertical({source = [] || {}, additionalInfo, additionalClass, link, isFullThumbnail}) {

  const convertJSONKey = (object, oldKey, newKey) => {
    object[newKey] = object[oldKey];
  }

  // Covert Keys
  if (source) {
    const arr = source
    arr.map(object =>
      convertJSONKey(object, 'source', 'brand',)          // 홈 매거진 카테고리
    );
  }

  return (
    <>
      {source && source.map((eachData, index) => {
          return (
            <div className={`ad-box large-vertical ${additionalClass}`} key={`ad-${index}`}>
              <a href={convertPath(`${link}${eachData.ukey}`)}>
                <div className="thumbnail-card-wrapper">
                  {
                    eachData.thumbnail.endsWith('.jpg') || eachData.thumbnail.endsWith('.png') ?
                      <LazyLoadImage className="thumbnail-card small-video" src={`${isFullThumbnail ? `${eachData.thumbnail.replace('/l/', '/m/').replace("http:", "https:")}` : `https://thumb.ad.co.kr${eachData.thumbnail.replace('/l/', '/m/').replace("http:", "https:")}`}`}/>
                  :
                      <LazyLoadImage className="thumbnail-card small-video"/>
                  }

                </div>
                <div className="ad-info">
                  <h4 className="title">{eachData.title.replace(/(<([^>]+)>)/ig,"")} </h4>
                  <div className="row-box">
                    <h5 className="brand">
                      {
                        eachData.brand === "" ? "Ad Magazine" : eachData.brand
                      }
                    </h5>
                    {
                      additionalInfo &&
                      <>
                        {
                          eachData.rcount !== 0 &&
                          <>
                            <div className="view-count">
                              <LazyLoadImage src={ViewIcon} alt=""/>
                              <span>{eachData.rcount}</span>
                            </div>
                            <LazyLoadImage src={Split} alt=""/>
                          </>
                        }
                        <div className="created-date">{Moments.Format(eachData.wdate, 'yyyy.MM.DD')}</div>
                      </>
                    }
                  </div>
                </div>
              </a>
            </div>
          )
        }
      )}
    </>
  );
}

export default LargeCardVertical;
